module.exports = __webpack_public_path__ + "img/logo-label.7e3b9494.png";